import { render, staticRenderFns } from "./IconsCustomization.vue?vue&type=template&id=2a7e32b0&scoped=true&"
import script from "./IconsCustomization.vue?vue&type=script&lang=js&"
export * from "./IconsCustomization.vue?vue&type=script&lang=js&"
import style0 from "./IconsCustomization.vue?vue&type=style&index=0&id=2a7e32b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7e32b0",
  null
  
)

export default component.exports